import { Link } from 'react-router-dom';

interface CategoryCardProps {
  slug: string;
  name: string;
  description: string;
  icon: string;
  articleCount: number;
}

export default function CategoryCard({
  slug,
  name,
  description,
  icon,
  articleCount,
}: CategoryCardProps) {
  return (
    <Link
      to={`/category/${slug}`}
      className="group bg-background-50 rounded-lg border border-background-200/70 p-6 hover:border-primary-200/60 transition-all duration-300 flex flex-col items-start gap-4"
    >
      <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 group-hover:bg-primary-100 group-hover:text-primary-600 transition-colors">
        <i className={`${icon} text-xl`} />
      </div>
      <div>
        <h3 className="font-heading font-semibold text-base text-foreground-900 mb-1.5 group-hover:text-primary-600 transition-colors whitespace-nowrap">
          {name}
        </h3>
        <p className="text-sm text-foreground-600 leading-relaxed mb-3 line-clamp-2">
          {description}
        </p>
        <span className="text-xs text-foreground-500 flex items-center gap-1">
          <i className="ri-article-line" />
          {articleCount} 篇文章
        </span>
      </div>
    </Link>
  );
}